import {createSubmitRequestTypes} from "./helpers";

export const REQUEST_CHANGE_PASSWORD = "ONBOARDING:REQUEST_CHANGE_PASSWORD";
export const CHANGE_PASSWORD = createSubmitRequestTypes("ONBOARDING:CHANGE_PASSWORD");
export const requestChangePassword = (customerId) => ({ type: REQUEST_CHANGE_PASSWORD, customerId });
export const cancelChangePassword = () => ({ type: CHANGE_PASSWORD.CANCEL });

export const REQUEST_INVITE_CUSTOMER = "ONBOARDING:REQUEST_INVITE_CUSTOMER";
export const INVITE_CUSTOMER = createSubmitRequestTypes("ONBOARDING:INVITE_CUSTOMER");
export const requestInviteCustomer = (customerId) => ({ type: REQUEST_INVITE_CUSTOMER, customerId });
export const cancelInviteCustomer = () => ({ type: INVITE_CUSTOMER.CANCEL });